const prod = {
  api: {
    baseUrl: 'https://ibacos-perform-api.ibacos.com/',
    jsonNamespace: 'api/v1/',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
};

const demo = {
  api: {
    baseUrl: 'https://ibacos-perform-api-demo.ibacos.org/',
    jsonNamespace: 'api/v1/',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
};

const sand = {
  api: {
    baseUrl: 'https://ibacos-perform-api-sand.ibacos.org/',
    jsonNamespace: 'api/v1/',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
};

const stg = {
  api: {
    baseUrl: 'https://ibacos-perform-api-stg.ibacos.org/',
    jsonNamespace: 'api/v1/',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
};

const dev = {
  api: {
    baseUrl: 'https://ibacos-perform-api-dev.ibacos.org/',
    jsonNamespace: 'api/v1/',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
};

const local = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    jsonNamespace: process.env.REACT_APP_API_JSON_NAMESPACE,
    clientId: process.env.REACT_APP_API_CLIENT_ID,
    clientSecret: process.env.REACT_APP_API_CLIENT_SECRET,
  },
};

let config = {};
switch (process.env.REACT_APP_ENV) {
  case 'prod':
    config = prod;
    break;
  case 'demo':
    config = demo;
    break;
  case 'dev':
    config = dev;
    break;
  case 'sand':
    config = sand;
    break;
  case 'stg':
    config = stg;
    break;
  default:
    config = local;
    break;
}

export default config;
